import unescapedText from 'I18n/utils/unescapedText';
import memoize from 'hs-lodash/memoize';
import * as CategoryV2 from 'marketplace-ui-apps-core/common/constants/groupTags/CategoryV2';
import { getAppCategoryI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import UIRouterSideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router-dom/UIRouterSideNavItem';
import { getCategoryV2Url } from '../../../../utils/urls';

// @ts-expect-error untyped import
import localeComparator from 'I18n/utils/localeComparator';
import { jsx as _jsx } from "react/jsx-runtime";
export const getCategoryV2Options = memoize(() => Object.values(CategoryV2).map(key => ({
  value: key,
  text: unescapedText(getAppCategoryI18nKey(key))
})).sort((optionA, optionB) => localeComparator(optionA.text, optionB.text)));
export function CategoryV2Filter({
  onChange,
  scrollable = true,
  value
}) {
  const isPrerender = getIsPrerenderUserAgent();
  const options = getCategoryV2Options();
  if (isPrerender) {
    return /*#__PURE__*/_jsx(UIRouterSideNav, {
      children: options.map(option => /*#__PURE__*/_jsx(UIRouterSideNavItem, {
        exact: false,
        title: option.text,
        to: getCategoryV2Url(option.value)
      }, option.value))
    });
  }
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.category.titleText'),
    multi: true,
    name: "categoryV2",
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    searchable: true,
    value: value
  });
}